import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';

export const menuWidth = 180;
export const menuWidthSmall = 48;

export const tabStyle = {
  '&.MuiTab-root': {
    maxWidth: '22.5rem',
    borderRadius: `${DEFAULT_BORDER_RADIUS} ${DEFAULT_BORDER_RADIUS} 0px 0px`,
    px: 24,
    py: 6,
    minHeight: '2rem',
    height: '2rem',
  },
};
